<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card>
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>投保须知</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text>
        <h3>特别约定</h3>  
        <p>（1）尊敬的客户，投保次日起，您可通过本公司网站、客服电话、营业网点核实保单及理赔等信息，若对查询结果有异议，请联系本公司。联系方式：www.zhufengic.com；客服电话：10108848。</p>
        <p>（2）保险人和投保人一致同意：本保险合同自投保人向保险人全额交纳约定的保险费时成立。缴费时间和保单起保时间，保险人以后者作为本保险合同的生效时间，自保险合同生效之时起开始承担保险责任。</p>
        <p>（3）保险人和投保人一致同意：如本特别约定与本保险条款约定相冲突，以本特别约定为准。</p>
        <p>（4）本保险合同一律采用书面形式，任何口头或其他形式的非书面约定，对本保险合同的当事人均没有法律约束力。</p>
        <p>（5）本保险合同限每一被保险人投保一份，多投部分无效。</p>
        <p>（6）本保险合同仅限于单一法人单位投保，存在分支机构的，分支机构需另行投保。</p>
        <p>（7）本保险合同承保营业场所不超过三个（投保时需提供地址，精确到门牌号），营业场所地址在湖北省内的不予承保。</p>
        <p>（8）本保险合同扩展因法定传染病（含新型冠状病毒（2019-nCoV）感染）导致停业，且固定资产被污染受损的财产损失责任，赔偿限额不超过保单保额。因法定传染病导致停业需有区县级及以上政府相关部门封闭或隔离的相关文件，并按文件要求停业隔离。</p>
        <p>（9）附加传染病营业中断保险等待期7天</p>
        <p>（10）本保险合同附加传染病营业中断保险承担因营业场所首次发现法定传染疾病（含新型冠状病毒（2019-nCoV））确诊病例，而被区县级及以上政府相关部门强制要求封闭或隔离，自封闭开始时间起至封闭结束时间止，期间产生的毛利润损失。</p>
        <p>（11）本保险合同附加传染病营业中断保险按被保险人企业每日毛利润损失进行赔偿，最高不超过每日毛利润赔偿限额，赔偿期限以实际营业中断时长（封闭或隔离时长）为准，最长不超过30天</p>
        <p>（12）偿付能力披露：截至2019年四季度末，我公司综合偿付能力充足率为182.07%，该偿付能力充足率达到监管要求。</p>
        <h3>投保人声明</h3>
        <p>1.投保人填写投保单之前，保险人已经就本投保单及后附的保险条款的内容，尤其是关于保险人免除责任的条款及投保人和被保险人义务条款向投保人作了明确说明，投保人对该保险条款及保险条件已完全了解，并同意接受保险条款的约束。</p>
        <p>2.投保单所填各项内容均属事实，同意以投保单作为保险人签发保险单的依据。</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style>
</style>
